module.exports = __webpack_public_path__ + "img/inserti_pannolino.33fd5513.jpg";